import {
  List,
  Datagrid,
  ChipField,
  ReferenceField,
  BooleanInput,
  BooleanField,
  TextField,
  ImageField,
  DeleteWithConfirmButton,
  Edit,
  SimpleForm,
  TextInput,
  ImageInput,
  Create,
  SelectInput,
  Show,
  SimpleShowLayout,
  RichTextField,
  DateField,
  required,
} from 'react-admin'

import { CustomRichTextInput } from '../components/CustomRichTextInput'

import { USER_TYPE_OPTIONS, MODAL_TYPE_OPTIONS } from '../config/constants'

export const ModalList = ({ isEdit, isDelete }) => (
  <List>
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? "edit" : "show"}>
      <ChipField source="userType" />
      <BooleanField source="isPremium" />
      <ChipField source="type" />
      <TextField source="title" />
      {/*<ImageField source="imageUrl" title="imageUrl" />*/}
      <DateField source="updatedAt" label="Updated At" showTime />
      <ReferenceField source="updatedBy" reference="users" />
      {isDelete && <DeleteWithConfirmButton confirmContent="This action could not be reverted. Are you sure?" />}
    </Datagrid>
  </List>
)

export const ModalEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="title" fullWidth multiline />
      {/* <TextInput source="description" fullWidth multiline /> */}
      <CustomRichTextInput size="medium" source="text" fullWidth />
      <ImageField source="imageUrl" title="imageUrl" />
      <ImageInput source="image">
        <ImageField source="src" title="title" />
      </ImageInput>
    </SimpleForm>
  </Edit>
)

export const ModalCreate = () => (
  <Create>
    <SimpleForm>
      <SelectInput source="userType" choices={USER_TYPE_OPTIONS} validate={required()} />
      <BooleanInput source="isPremium" label="Is Premium" validate={required()} />
      <SelectInput source="type" choices={MODAL_TYPE_OPTIONS} validate={required()} />
      <TextInput source="title" fullWidth multiline validate={required()} />
      {/* <TextInput source="description" fullWidth multiline /> */}
      <CustomRichTextInput size="medium" source="text" fullWidth validate={required()} />
      <ImageField source="imageUrl" title="imageUrl" />
      <ImageInput source="image">
        <ImageField source="src" title="title" />
      </ImageInput>
    </SimpleForm>
  </Create>
)

export const ModalShow = () => (
  <Show>
    <SimpleShowLayout>
      <ChipField source="userType" />
      <BooleanField source="isPremium" />
      <ChipField source="phaseType" />
      <ChipField source="type" />
      <TextField source="title" />
      {/* <TextField source="description" /> */}
      <RichTextField source="text" />
      <ImageField source="imageUrl" title="imageUrl" />
      <ImageField source="previewImageUrl" title="previewImageUrl" />
      <DateField source="updatedAt" label="Updated At" showTime />
      <ReferenceField source="updatedBy" reference="users" />
    </SimpleShowLayout>
  </Show>
)
